export default {
  QUEUE_LENGTH: 'queue_length',
  INSTITUTION_NAME: 'institution_name',
  POSITION_NAME: 'position_name',
  NAME: 'name',
  CLIENT_ID: 'client_id',
};
